import PropTypes from 'prop-types';
import { CardMedia, Typography } from '@mui/material'

const ThumbImage = ({ poll, onClick, children, minWidth, minHeight, maxWidth, maxHeight, hoverEffect = true }) => {
  minWidth = minWidth ?? 102
  minHeight = minHeight ?? 102
  maxWidth = maxWidth ?? 102
  maxHeight = maxHeight ?? 102
  return (
    <CardMedia
      onClick={onClick}
      image={poll.thumbnail ? `${process.env.REACT_APP_API_URL}/static/thumbnails/${poll.thumbnail}`: `${process.env.PUBLIC_URL}/image/application_image_thumb/large.webp`}
      sx={{
        minWidth,
        minHeight,
        maxWidth,
        maxHeight,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundColor: 'black',
        borderRadius: 1,
        ...(hoverEffect && {
          cursor: 'pointer',
          '&:hover': {
            opacity: 0.5
          }
        })
      }}
    >
      {children?.length > 0 && <Typography textAlign={'center'} sx={{ fontSize: '6rem', color: 'grey' }}>
        {children}
      </Typography>}
    </CardMedia>
  )
}
ThumbImage.propTypes = {
  poll: PropTypes.any.isRequired,
  onClick: PropTypes.func,
  children: PropTypes.element,
  hoverEffect: PropTypes.bool,
  minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default ThumbImage
